import { useAccount, useSwitchChain } from "wagmi";
import { useNetworkState } from "../../utils/useNetwork";
import { message, Modal, Spin } from "antd";
import { FaCircleCheck } from "react-icons/fa6";
import { useState } from "react";

const supportedChains = [
  {
    chainId: 56,
    logo: "/images/bnb.png",
    name: "BNB Chain",
  },
  {
    chainId: 1,
    logo: "/images/eth-item.png",
    name: "Ethereum",
  },
  {
    chainId: 43114,
    logo: "/images/avax.png",
    name: "Avalanche",
  },
  {
    chainId: 8453,
    logo: "/images/base.png",
    name: "Base",
  },
  {
    chainId: 137,
    logo: "/images/poly.png",
    name: "Polygon",
  },
  {
    chainId: 42161,
    logo: "/images/arb.png",
    name: "Arbitrum",
  },
  {
    chainId: 185,
    logo: "/images/mint.png",
    name: "Mint",
  },
  {
    chainId: 995,
    logo: "/images/5ire.png",
    name: "5ireChain",
  },
  {
    chainId: 8668,
    logo: "/images/hela.png",
    name: "HeLa",
  },
  {
    chainId: 146,
    logo: "/images/sonic.png",
    name: "Sonic",
  },
  ...(process.env.REACT_APP_ENV !== "production"
    ? [
        {
          chainId: 97,
          logo: "/images/bnb.png",
          name: "BNB Testnest",
        },
      ]
    : []),
];

const NetworkModal = ({
  chainNotConnect,
  setChainNotConnect,
  modalOpen,
  setModalOpen,
}: {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  chainNotConnect: number;
  setChainNotConnect: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const selectedNetworkIds: any = useNetworkState();
  const { switchChainAsync } = useSwitchChain();
  const { address }: any = useAccount();
  const [loading, setLoading] = useState<number | undefined>(undefined);

  const handleSwitchChain = async (key: any) => {
    if (address) {
      if (selectedNetworkIds !== key) {
        try {
          setLoading(key);
          const response = await switchChainAsync({ chainId: key });
          if (response)
            message.success({
              content: "Switched Chain Successfully",
              className: "custom-class",
              duration: 2,
            });
        } catch (error: any) {
          if (error.name === "UserRejectedRequestError" || error.code === 4001)
            return;
          else
            message.error({
              content: "Failed to switch chain. Check your wallet connection.",
              className: "custom-class",
              duration: 2,
            });
        } finally {
          setModalOpen(false);
          setLoading(undefined);
        }
      }
    } else {
      setChainNotConnect(key);
      setModalOpen(false);
    }
  };

  return (
    <Modal
      title={null}
      open={modalOpen}
      footer={null}
      onCancel={() => setModalOpen(false)}
      centered
      className="xl:min-w-[600px]"
    >
      <div className="xs:px-2 md:px-4 py-2">
        <div className="mt-2 font-Azonix text-[26px] xxs:text-3xl xs:text-4xl text-center">
          Select Network
        </div>
        <div className="mt-4 md:mt-6 grid grid-cols-2 xs:grid-cols-3 sm:grid-cols-4 gap-2">
          {supportedChains.map((chain) => (
            <div
              key={chain.chainId}
              className="py-3 px-1 bg-customBlue-200 rounded-lg flex flex-col gap-1 items-center relative cursor-pointer 
              transition-transform duration-300 ease-in-out hover:bg-customBlue-300 hover:scale-90"
              onClick={() => handleSwitchChain(chain.chainId)}
            >
              {((address && selectedNetworkIds === chain.chainId) ||
                (!address && chainNotConnect === chain.chainId)) && (
                <FaCircleCheck
                  className="absolute top-2 right-2 text-green-600 z-10"
                  size={16}
                />
              )}
              {loading === chain.chainId && (
                <Spin className="absolute top-2 right-2 z-20" />
              )}
              <img
                src={chain.logo}
                alt="logo"
                className="w-8 h-8 object-cover object-center"
              />
              <div className="text-text-primary font-Montserrat font-medium whitespace-nowrap">
                {chain.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default NetworkModal;
